import React from 'react';

import { type OptionType } from '@atlaskit/select';

import {
	OffStatus,
	PendingStatus,
	ResponsiveStatus,
	UnresponsiveStatus,
} from '../../../../../common/ui/status-labels';

export const Option: React.FC<{ option: OptionType }> = ({ option }) => {
	switch (option.value) {
		case 'Pending':
			return <PendingStatus />;
		case 'Responsive':
			return <ResponsiveStatus />;
		case 'Unresponsive':
			return <UnresponsiveStatus />;
		case 'Off':
			return <OffStatus />;
		default:
			return <></>;
	}
};
